import { useEffect } from 'react';
import { useHook } from '..';
import { getCurveLabel } from '../../services';
import { CommonData, Curve } from '../../models';
import { CurrentUnit, SpeedUnit, TorqueUnit } from '../../enums';
import { useAppDispatch, useAppSelector, useTranslate } from '../common';
import { setDiagramData, setIsAbsoluteScaling, setMesRequest, toggleLoading } from '../../store';


export const useDiagram = () => {
    const translate = useTranslate();
    const dispatch = useAppDispatch();
    const curves = useAppSelector(state => state.diagram.diagramData);
    const language = useAppSelector(state => state.translation.language);
    const mesRequest = useAppSelector(state => state.motor.mesRequest);
    const { getCalculationData } = useHook(x => x.filter)();

    useEffect(() => {
        const { torqueUnit, speedUnit, currentUnit } = mesRequest.commonData;

        dispatch(setIsAbsoluteScaling(torqueUnit === TorqueUnit.Nm && speedUnit === SpeedUnit.Rpm && currentUnit === CurrentUnit.A));
    }, []);

    useEffect(() => {
        if (curves) {
            const updatedCurves = curves.map(curve => ({
                ...curve, label: getCurveLabel(curve.curveType, mesRequest.commonData.startingVoltage, mesRequest.commonData.startingType, translate)
            } as Curve));

            dispatch(setDiagramData(updatedCurves));
        }
    }, [language]);

    const handleDiagramChange = async (subset: Partial<CommonData>) => {
        dispatch(toggleLoading());

        const newMesRequest = { ...mesRequest, commonData: { ...mesRequest.commonData, ...subset } };

        dispatch(setMesRequest(newMesRequest));

        await getCalculationData(newMesRequest);

        dispatch(toggleLoading());
    };

    return {
        onDiagramChange: handleDiagramChange
    };
};
